import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import ActionButtons from "../../../../../components/ActionButtons";
import { changeStatus, setGrid } from "../../utils/slice";
import { useState } from "react";
import ConfirmModal from "../../../../../components/Modals/ConfirmModal";
import useColumnDefs from "./useColumnDefs";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";
import React from "react";

/**
 * Renders the Listing component for CusomerAccess module.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.moduleInfo - Information about the module.
 * @param {Function} props.handleViewClick - The click event handler for viewing details of a user profile.
 * @param {Function} props.handleEditClick - The click event handler for editing user profile.
 * @return {JSX.Element} The rendered Listing component.
 */
const Listing: React.FC<any> = ({
  moduleInfo,
  handleEditClick,
  handleDeleteClick
}) => {
  const columnDefs = useColumnDefs;
  const [statusData, setStatusData] = useState<any>();
  const acronyms = useAppSelector((state: RootState) => state.acronyms);
  const ActionRenderer = (props: any) => {
    return (
      <ActionButtons
        data={props}
        
        edit={{
          action: handleEditClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_UPDATE`,
        }}
        deleteButton={{
          action: handleDeleteClick,
          permissionKey: `${moduleInfo.permissionKeyPrefix}_DELETE`,
        }}
      />
    );
  };

  return (
    <>
      <ConfirmModal
        titleName={moduleInfo.title}
        data={statusData}
        close={() => setStatusData(null)}
        callApi={changeStatus}
      />
      <AgGridWrapper
        components={{
          ActionRenderer,
        }}
        rowData={acronyms.rowData}
        onGridReadyWithDispatch={setGrid}
        columnDefs={columnDefs}
        context={{ setStatusData }}
        paginationPageSize={acronyms.perPage}
        cacheBlockSize={acronyms.perPage}
      />
    </>
  );
};

export default Listing;
